import angular from "angular";
import labels from "emun.report/_labels";
import formConst from "emun.report/report-params.formio";
import config from "emun.report/report.config";
import resolve from "ioc/resolve";
import AutoQuery from "servicestack/auto-query/auto-query";
import ServiceBus from "servicestack/service-bus";
import formioController from "webforms/formio/formio.controller";

export default class ReportParamsController {
  constructor($scope, options) {
    const $ctrl = this;
    formioController($ctrl, $scope);
    $ctrl.customers = [];
    $ctrl.retailerResults = [];
    $ctrl.customerKeys = ["customer", "billTo", "billTos"];
    $ctrl.shipToKeys = ["shipID", "shipTos"];
    $ctrl.vendorKeys = ["brands", "division"];
    $ctrl.categoryKeys = ["productCategories", "categories"];
    $ctrl.subcategoryKeys = [
      "productSubCategories",
      "subcategories",
      "collections",
    ];
    $ctrl.warehouseKeys = ["warehouses", "factory"];
    $ctrl.pricelistKeys = ["priceList"];
    $ctrl.bus = new ServiceBus();
    $ctrl.title = options.title || " Report Parameters...";
    $ctrl.report = options.report || {};
    $ctrl.paramsOnly = options.paramsOnly;
    $ctrl.submission = {
      label: "report-params",
      data: {
        reportName: $ctrl.report.name,
        displayName: $ctrl.report.displayName,
        output: $ctrl.report.output,
        instructions: $ctrl.report.instructions,
        serviceReport: $ctrl.report.serviceReport,
        serviceUrl: $ctrl.report.serviceUrl,
      },
    };
    $ctrl.submission.data.vendorsShowInactive = config.vendorsShowInactive;
    $ctrl.showCustomer = false;
    $ctrl.showCustomerMultiple = false;
    $ctrl.submitted = false;
    $scope.$watch("$ctrl.submission.data.vendorsShowInactive", function (res) {
      if ($ctrl.vendorsQuery != undefined) {
        if ($ctrl.submission.data.vendorsShowInactive) {
          $ctrl.vendorsQuery.url = "QueryVendors.json?includeInactive=1";
        } else {
          $ctrl.vendorsQuery.url = "QueryVendors.json?Vendor=True";
        }
        $ctrl.vendorsQuery.criteria.take = 1000;
        if ($ctrl.$session.isVendor()) {
          if ($ctrl.$session.vendorGroup) {
            $ctrl.vendorsQuery.url =
              $ctrl.vendorsQuery.url +
              "&VendorGroup=" +
              $ctrl.$session.vendorGroup;
          } else {
            $ctrl.vendorsQuery.url =
              $ctrl.vendorsQuery.url + "&VendorID=" + $ctrl.$session.retailerId;
          }
        }
        $ctrl.vendorsQuery.load(true);
      }
    });

    const [report] = config.reports.filter(
      (m) => m.name.toUpperCase() === $ctrl.report.name.toUpperCase()
    );
    console.info("$ctrl.report", $ctrl.report);
    if (report) {
      if (
        $ctrl.$session.isRep() ||
        $ctrl.$session.salesRepId == "Inside Sales"
      ) {
        report.params = report.params.filter(function (e) {
          return e !== "repID";
        });
      }

      const paramMap = report.params.reduce(
        (agg, m) => Object.assign(agg, { [m.toUpperCase()]: m }),
        {}
      );

      $ctrl.submission.data.params = $ctrl.params = [...report.params];

      //check for any customer keys in config
      $ctrl.customerKeys.forEach(function (key) {
        if ($ctrl.params.indexOf(key) > -1) {
          $ctrl.showCustomer = true;
        }
      });
      if ($ctrl.params.indexOf("customers") > -1)
        $ctrl.showCustomerMultiple = true;

      $ctrl.instructions = report.instructions || "";
      $ctrl.serviceReport = report.serviceReport || "";
      $ctrl.serviceUrl = report.serviceUrl || "";
      $ctrl.submission.data.reportName = report.reportName;
      $ctrl.submission.data.displayName = $ctrl.report.displayName;
      $ctrl.submission.data.output = report.output || labels.defaultOutput;
      $ctrl.submission.data.startDate =
        report.startDate || moment().subtract(3, "months");
      $ctrl.submission.data.endDate = report.endDate || moment();
      $ctrl.submission.data.startDate2 =
        report.startDate2 || moment().subtract(3, "months");
      $ctrl.submission.data.endDate2 = report.endDate2 || moment();

      $ctrl.submission.data.period1Start =
        report.period1Start || moment().subtract(3, "months");
      $ctrl.submission.data.period1End = report.period1End || moment();
      $ctrl.submission.data.period2Start =
        report.period2Start || moment().subtract(3, "months");
      $ctrl.submission.data.period2End = report.period2End || moment();
      $ctrl.submission.data.period3Start =
        report.period3Start || moment().subtract(3, "months");
      $ctrl.submission.data.period3End = report.period3End || moment();
      $ctrl.submission.data.period4Start =
        report.period4Start || moment().subtract(3, "months");
      $ctrl.submission.data.period4End = report.period4End || moment();

      $ctrl.submission.data.cellLoad = report.cellLoad;
      $ctrl.submission.data.reformat = report.reformat;
      $ctrl.submission.data.imageFromBucket = report.imageFromBucket;
      $ctrl.submission.data.runDate = moment();
      $ctrl.submission.data.userTimeZone = moment.tz.guess();
      $ctrl.submission.data.userTimeZoneId = moment
        .tz($ctrl.submission.data.userTimeZone)
        .zoneAbbr();
      $ctrl.submission.data.userTimeZoneOffset = moment().utcOffset();
      //console.debug("TimeZones", $ctrl.submission.data.userTimeZone, $ctrl.submission.data.userTimeZoneId, $ctrl.submission.data.userTimeZoneOffset, moment.tz($ctrl.submission.data.userTimeZone).format());
      if (report.defaultParams) {
        report.defaultParams.forEach(function (param) {
          //console.info("param.value", param.value);
          //console.info("param.key", param.key);
          $ctrl.submission.data[param.key] = param.value;
          console.info(
            "$ctrl.submission.data[param.key]",
            $ctrl.submission.data[param.key]
          );
        });
      }
      const form = angular.merge({}, formConst);
      form.components.forEach(function (section) {
        //console.info("section.key", section.key);
        section.hidden = false;
        if (section.type === "select" && section.multiple) {
          section.valueProperty = "value";
        }
        if (
          section.key !== "submit" &&
          !(section.key.toUpperCase() in paramMap)
        ) {
          section.hidden = true;
        } else {
          section.key = paramMap[section.key.toUpperCase()];
          if (section.key === "priceList") {
            //section.hidden = !$ctrl.$session.isRepOrAbove();
          }
        }
        if (
          report.requiredParams &&
          report.requiredParams.indexOf(section.key) > -1
        ) {
          section.validate.required = true;
        }
        if ($ctrl.customerKeys.indexOf(section.key) > -1) {
          section.hidden = true;
        }
        if ($ctrl.shipToKeys.indexOf(section.key) > -1) {
          section.hidden = true;
        }

        if (labels[section.key]) {
          section.label = labels[section.key];
        } else if (labels[section.key] === "") {
          section.hidden = true;
        }
        if (report.labels) {
          if (report.labels[section.key] === false) {
            section.hidden = true;
          } else if (section.key in report.labels) {
            section.label = report.labels[section.key];
          }
        }
        if (section.key === "startDate") {
          if ($ctrl.report.name.toUpperCase().indexOf("INVOICE") > -1) {
            section.label = "Invoice Start Date";
          } else if ($ctrl.report.name.toUpperCase().indexOf("ORDER") > -1) {
            section.label = "Order Start Date";
          }
        }
        if (section.key === "endDate") {
          if ($ctrl.report.name.toUpperCase().indexOf("INVOICE") > -1) {
            section.label = "Invoice End Date";
          } else if ($ctrl.report.name.toUpperCase().indexOf("ORDER") > -1) {
            section.label = "Order End Date";
          }
        }
        if (section.key === "startDate2") {
          if ($ctrl.report.name.toUpperCase().indexOf("INVOICE") > -1) {
            section.label = "Invoice Start Ship Date";
          } else if ($ctrl.report.name.toUpperCase().indexOf("ORDER") > -1) {
            section.label = "Order Start Ship Date";
          }
        }
        if (section.key === "endDate2") {
          if ($ctrl.report.name.toUpperCase().indexOf("INVOICE") > -1) {
            section.label = "Invoice End Ship Date";
          } else if ($ctrl.report.name.toUpperCase().indexOf("ORDER") > -1) {
            section.label = "Order End Ship Date";
          }
        }
        if (report.rekey && section.key in report.rekey) {
          const oldKey = section.key;
          const newKey = report.rekey[section.key];
          $ctrl.submission.data.params = [
            ...$ctrl.submission.data.params.filter((p) => p !== oldKey),
            newKey,
          ];
          section.key = newKey;
        }
      });
      $ctrl.form = form;

      //$ctrl.submission.data.params.forEach(function (param) {
      //  console.info("param", param);
      //});

      if (
        $ctrl.submission.data.params.includes(labels["vendors"]) ||
        $ctrl.submission.data.params.includes("vendors")
      ) {
        var url = "QueryVendors.json";
        if ($ctrl.$session.isVendor()) {
          if ($ctrl.$session.vendorGroup) {
            url = url + "?VendorGroup=" + $ctrl.$session.vendorGroup;
          } else {
            url = url + "?VendorID=" + $ctrl.$session.retailerId;
          }
        }
        $ctrl.vendorsQuery = new AutoQuery({
          url: url,
          autoLoad: true,
          orderBy: "Label",
          take: 1000,
          onLoaded: function (res) {
            var values = [];
            res.results.forEach(function (obj) {
              values.push({ value: obj.id, label: obj.vendorName });
            });
            $ctrl.submission.data.vendorValues = values;
          },
        });
      }

      if (
        $ctrl.submission.data.params.includes(labels["productCategories"]) ||
        $ctrl.submission.data.params.includes("productCategories") ||
        $ctrl.submission.data.params.includes(labels["categories"]) ||
        $ctrl.submission.data.params.includes("categories")
      ) {
        $ctrl.bus
          .send("QueryAssignedProductCategories.json")
          .then(function (res) {
            var values = [];
            res.data.results.forEach(function (obj) {
              values.push({ value: obj.id, label: obj.label });
            });
            $ctrl.submission.data.categoryValues = values;
          });
      }

      if ($ctrl.submission.data.params.includes("customerCategory")) {
        $ctrl.bus
          .send("QueryCustomFieldValues.json?Id=CustomerCategory")
          .then(function (res) {
            var values = [];
            res.data.results.forEach(function (obj) {
              values.push({ value: obj.valueID, label: obj.valueName });
            });
            $ctrl.submission.data.customerCategoryValues = values;
          });
      }

      if ($ctrl.submission.data.params.includes("orderOptions")) {
        $ctrl.bus
          .send("QueryCustomFieldValues.json?Id=OrderOptions")
          .then(function (res) {
            var values = [];
            res.data.results.forEach(function (obj) {
              values.push({ value: obj.valueID, label: obj.valueName });
            });
            $ctrl.submission.data.orderOptionsValues = values;
          });
      }

      if ($ctrl.submission.data.params.includes("DocType")) {
        $ctrl.bus
          .send("QueryCustomFieldValues.json?Id=DocumentTypes")
          .then(function (res) {
            var values = [];
            res.data.results.forEach(function (obj) {
              values.push({ value: obj.valueID, label: obj.valueName });
            });
            $ctrl.submission.data.docTypeValues = values;
          });
      }

      if (
        $ctrl.submission.data.params.includes(labels["productLines"]) ||
        $ctrl.submission.data.params.includes("productLines") ||
        $ctrl.submission.data.params.includes("brands")
      ) {
        $ctrl.bus
          //.send("QueryProductLines.json?IdIn=BY,HFC,HU,SMDomestic")
          //we now only pull the product lines that have ysnBackorders as true (default is true) -- if we want to ignore PL, set ysnBackorders to false for that record
          .send("QueryProductLines.json?BackOrders=true")
          .then(function (res) {
            var values = [];
            res.data.results.forEach(function (obj) {
              values.push({ value: obj.id, label: obj.label });
            });
            $ctrl.submission.data.productLineValues = values;
          });
      }

      if ($ctrl.submission.data.params.includes("period")) {
        $ctrl.bus
          .send("QueryCommissionPeriods.json?OrderByDesc=PeriodId")
          .then(function (res) {
            var values = [];
            res.data.results.forEach(function (obj) {
              values.push({
                value: obj.periodId,
                label: obj.periodId + " - " + obj.status,
              });
            });
            $ctrl.submission.data.periodValues = values;
          });
      }

      //if ($ctrl.submission.data.params.includes(labels["productSubCategories"]) || $ctrl.submission.data.params.includes("productSubCategories") || $ctrl.submission.data.params.includes(labels["subcategories"]) || $ctrl.submission.data.params.includes("subcategories") || (report.labels != undefined && $ctrl.submission.data.params.includes(report.labels.productSubCategories.toLowerCase()))) {
      $ctrl.loadValues(
        "QueryAssignedProductSubCategories.json",
        "subcategoryValues",
        {},
        (obj) => ({
          value: obj.strSubCategoryName,
          label: obj.strSubCategoryDescription,
        })
      );
      //}

      if (
        $ctrl.submission.data.params.includes(
          labels["productSuperCategories"]
        ) ||
        $ctrl.submission.data.params.includes("productSuperCategories") ||
        $ctrl.submission.data.params.includes(labels["supercategories"]) ||
        $ctrl.submission.data.params.includes("supercategories") ||
        $ctrl.submission.data.params.includes("superCategories")
      ) {
        $ctrl.loadValues(
          "QueryProductSuperCategories.json",
          "supercategoryValues",
          {},
          (value) => ({ value, label: value })
        );
      }

      if (report.reportName === "HKF050ItemAvailability") {
        // $ctrl.loadValues(
        //   "QueryWarehouses.json?IdIn=Asia FOB,US East,Fookyik Vietnam,1711&OrderBy=Name",
        //   "warehouseValues"
        // );
        $ctrl.submission.data.warehouseValues = [
          {
            value: "US East",
            label: "US East",
          },
          {
            value: "Asia FOB",
            label: "Asia FOB",
          },
          {
            value: "Fookyik Vietnam",
            label: "Fookyik Vietnam",
          },
          {
            value: "1711",
            label: "Kaiser Furniture",
          },
          {
            value: "Vista",
            label: "Vista",
          },
          {
            value: "Savannah",
            label: "Savannah",
          },
        ];
      }

      if (report.reportName === "HKF050FactoryItemAvailability") {
        $ctrl.loadValues(
          "QueryWarehouses.json?IdIn=Asia FOB,Vietnam Consolidated FOB&OrderBy=Name",
          "warehouseValues"
        );
      }

      if (report.reportName === "HKF050FactoryPhotoSheet") {
        $ctrl.loadValues(
          "QueryWarehouses.json?IdNotIn=Asia FOB,US East&OrderBy=Name",
          "warehouseValues"
        );
      }

      if (report.reportName === "TopSellingItems") {
        $ctrl.loadValues(
          "QueryWarehouses.json?OrderBy=Name",
          "warehouseValues"
        );
      }

      if (report.params.indexOf("priceList") >= 0) {
        if (report.reportName.indexOf("HKF050Factory") === 0) {
          $ctrl.submission.data.priceListValues = [
            "ConFOB",
            "ConFOB_DDP",
            "Container",
          ].map((value) => ({ value, label: value }));
        } else {
          $ctrl.loadValues(
            "QueryPriceLists.json?GroupBy=PriceListId",
            "priceListValues",
            {},
            (obj) => ({ value: obj.priceListId, label: obj.priceListId })
          );
        }
      }

      if ($ctrl.submission.data.params.includes("showCode")) {
        $ctrl.loadValues(
          "QueryShowCodes.json?All=true&OrderBy=Name",
          "showCodeValues",
          {},
          (obj) => ({ value: obj.id, label: obj.name })
        );
      }
      if ($ctrl.submission.data.params.includes("terms")) {
        $ctrl.loadValues(
          "QueryAllPaymentTerms.json?OrderBy=Name",
          "termsValues",
          {},
          (obj) => ({ value: obj.id, label: obj.name })
        );
      }
      if ($ctrl.submission.data.params.includes("repGroup")) {
        $ctrl.loadValues(
          "QueryRepGroups.json?OrderBy=Name",
          "repGroupValues",
          {},
          (obj) => ({ value: obj.id, label: obj.name })
        );
      }
      if ($ctrl.submission.data.params.includes("region")) {
        $ctrl.loadValues(
          "QueryRegions.json?OrderBy=Name",
          "regionValues",
          {},
          (obj) => ({ value: obj.id, label: obj.name })
        );
      }
      if ($ctrl.submission.data.params.includes("orderSource")) {
        $ctrl.loadValues(
          "QueryOrderSources.json?OrderBy=Label",
          "orderSourceValues",
          {},
          (obj) => ({ value: obj.id, label: obj.label })
        );
      }

      if ($ctrl.submission.data.params.includes("transactionType")) {
        $ctrl.loadValues(
          "QueryTransactionTypes.json?OrderBy=Description",
          "transactionTypeValues",
          {},
          (obj) => ({ value: obj.id, label: obj.description })
        );
      }

      if ($ctrl.submission.data.params.includes("repID")) {
        $ctrl.loadValues(
          "QuerySalesRepList.json?Active=1&OrderBy=Name",
          "salesRepValues"
        );
      }

      if ($ctrl.submission.data.params.includes("activityType")) {
        $ctrl.loadValues(
          "QueryActivityTypes.json?OrderBy=Type",
          "activityTypeValues",
          {},
          (obj) => ({ value: obj.type, label: obj.type })
        );
      }

      if ($ctrl.submission.data.params.includes("accountType")) {
        $ctrl.loadValues(
          "QueryAccountTypes.json?OrderBy=Name",
          "accountTypeValues",
          {},
          (obj) => ({ value: obj.id, label: obj.name })
        );
      }

      if ($ctrl.submission.data.params.includes("location")) {
        $ctrl.loadValues(
          "QueryShowVendorLocations.json",
          "locationValues",
          {},
          (obj) => ({ value: obj, label: obj })
        );
      }

      if (config.erpStatuses) {
        $ctrl.submission.data.erpStatusValues = config.erpStatuses;
      } else {
        if ($ctrl.submission.data.params.includes("erpStatuses")) {
          $ctrl.loadValues(
            "QueryCarts.json?GroupBy=ErpStatus",
            "erpStatusValues",
            {},
            (obj) => ({ value: obj.erpStatus, label: obj.erpStatus })
          );
        }
      }

      if (config.orderStatuses) {
        $ctrl.submission.data.orderStatusValues = config.orderStatuses;
      } else {
        if ($ctrl.submission.data.params.includes("orderStatuses")) {
          $ctrl.loadValues(
            "QueryCarts.json?GroupBy=Status",
            "orderStatusValues",
            {},
            (obj) => ({ value: obj.status, label: obj.status })
          );
        }
      }

      if ($ctrl.submission.data.params.includes("promoCodes")) {
        $ctrl.loadValues(
          "Querypromotions.json?GroupBy=strPromotionCode,strPromotionDesc",
          "promotionValues",
          {},
          (obj) => ({
            value: obj.strPromotionCode,
            label: obj.strPromotionDesc,
          })
        );
      }

      if ($ctrl.submission.data.params.includes("salesGroup")) {
        $ctrl.loadValues(
          "QueryRetailers?groupby=strSource",
          "salesGroupValues",
          {},
          (obj) => ({
            value: obj.strSource,
            label: obj.strSource,
          })
        );
      }

      if ($ctrl.submission.data.params.includes("locationType")) {
        $ctrl.loadValues(
          "QueryRetailers?groupby=strLocationType",
          "locationTypeValues",
          {},
          (obj) => ({
            value: obj.strLocationType,
            label: obj.strLocationType,
          })
        );
      }

      if ($ctrl.submission.data.params.includes("customerSources")) {
        $ctrl.loadValues(
          "QueryRetailers?groupby=strSource",
          "customerSourcesValues",
          {},
          (obj) => ({
            value: obj.strSource,
            label: obj.strSource,
          })
        );
      }

      if (config.defaultOrderStatuses) {
        $ctrl.submission.data.defaultOrderStatusesValues =
          config.defaultOrderStatuses;
      } else {
      }

      if (config.customerStatuses) {
        $ctrl.submission.data.customerStatusValues = config.customerStatuses;
      } else {
      }
    }

    $ctrl.submission.data.erpStatusValues = config.erpStatuses;
    $ctrl.submission.data.lineStatusValues = config.lineStatuses;
    $ctrl.submission.data.itemStatusValues = config.itemStatuses || [];
    $ctrl.submission.data.dataAnalysisReportsValues =
      config.dataAnalysisReports;
    $ctrl.submission.data.customerStatuses = config.customerStatuses;
    $ctrl.submission.data.defaultOrderStatuses = config.defaultOrderStatuses;
    console.info("config.defaultOrderStatuses", config.defaultOrderStatuses);
  }

  loadValues(
    url,
    fieldName,
    criteria = {},
    mapper = (obj) => ({ value: obj.id, label: obj.name })
  ) {
    const $ctrl = this;
    $ctrl.bus
      .read(url, criteria)
      .then(
        (res) =>
          ($ctrl.submission.data[fieldName] = res.data.results.map(mapper))
      );
  }

  findRetailers(val) {
    const $ctrl = this;
    let url = `QueryRetailersSearch.json?Take=25&Status=Active&Search=${val}&OrderBy=CompanyName`; //
    console.log("QueryRetailersSearch.$item", url);
    return $ctrl.bus.send(url).then((res) => res.data.results);
  }

  searchRetailers(val) {
    const $ctrl = this;
    let url = `QueryRetailersSearch.json?Take=25&Status=Active&Search=${val}&OrderBy=CompanyName`;
    $ctrl.bus.send(url).then(function (res) {
      $ctrl.retailerResults = res.data.results;
    });
  }

  selectRetailer(val) {
    const $ctrl = this;
    var retailerQuery = new AutoQuery({
      url: "QueryRetailers.json?Id=" + val.id,
      orderBy: "CompanyName",
      autoLoad: true,
      onLoaded(args) {
        $ctrl.customer = args.first;
        $ctrl.submission.data.customer = $ctrl.customer.id;
        $ctrl.submission.data.billTo = $ctrl.customer.id;
        $ctrl.submission.data.billTos = $ctrl.customer.id;
        $ctrl.locations = new AutoQuery({
          url:
            "QueryRetailerShippingLocations.json?Status=Active&retailerId=" +
            $ctrl.customer.id,
          orderBy: "Name",
          autoLoad: true,
          pageSize: 1000,
          take: 1000,
          onLoaded(args) {
            if (args.total === 1) {
              $ctrl.locationSelected(args.results[0]);
            }
          },
        });
      },
    });
  }

  selectLocation() {
    const $ctrl = this;
    $ctrl.locations.results.forEach(function (location) {
      if (location.id === $ctrl.shipId) {
        $ctrl.locationSelected(location);
      }
    });
  }

  locationSelected(location) {
    const $ctrl = this;
    $ctrl.location = location;
    $ctrl.submission.data.shipID = $ctrl.location.id;
    $ctrl.submission.data.shipTo = $ctrl.location.id;
    $ctrl.submission.data.shipTos = $ctrl.location.id;
    $ctrl.shipId = $ctrl.location.id;
    $ctrl.shipTos = $ctrl.location.id;
  }

  formSubmitting(e, submission) {
    const $ctrl = this;
    console.debug("formSubmitting", { $ctrl, e, submission });
    if (Array.isArray(submission.data.warehouses)) {
      submission.data.warehouses = submission.data.warehouses.reduce(
        (a, m) => (m ? [...a, ...m.toString().split(",")] : a),
        []
      );
    }
  }

  formSubmission(e, submission) {
    const $ctrl = this;
    console.debug("formSubmission", { $ctrl, e, submission });

    $ctrl.submission = submission;
    if ($ctrl.showCustomerMultiple && $ctrl.customers.length > 0) {
      $ctrl.submission.data.customers = $ctrl.customers.join(",");
    }
    $ctrl.$broadcast("$reportSubmitted");
    //$ctrl.$dismiss();
    //added this where we can create a report that calls EMUN1 service vs legacy API
    if ($ctrl.paramsOnly) {
      // var params = {}
      // let i = 0;
      // while (i < $ctrl.params.length) {
      // 	params[$ctrl.params[i]]  = submission.data[$ctrl.params[i]];
      // 	i++;
      // }
      $ctrl.$close($ctrl.submission.id);
    } else {
      if ($ctrl.serviceReport) {
        var queryParams = "";
        let i = 0;
        while (i < $ctrl.params.length) {
          queryParams +=
            $ctrl.params[i] + "=" + submission.data[$ctrl.params[i]] + "&";
          i++;
        }
        window.location = $ctrl.$appConfig.resolveServiceUrl(
          `${$ctrl.serviceUrl}?${queryParams}`
        );
      } else {
        window.location = $ctrl.$appConfig.resolveServiceUrl(
          `RunReport/${$ctrl.submission.id}`
        );
      }
    }

    //window.open($ctrl.$appConfig.resolveServiceUrl( 'RunReport/' + $ctrl.submission.id), '_blank', false);
    $ctrl.submitted = true;
    //resolve("$timeout")($ctrl.submitted = true, 3000);
    const $timeout = resolve("$timeout");
    $timeout(function () {
      $ctrl.submitted = false;
    }, 5000);
    $ctrl.submission = {
      label: "report-params",
      data: submission.data,
      saved: false,
      state: "submitted",
    };
  }
}
